import { chatBottomBar, chatFiles, chatInputBox} from "@components/chat/Chat.style";
import {createStyles, Theme} from "@material-ui/core";
import {buttonContained, buttonOutlined, secondaryColor, styleColors} from "src/main.style";

export const EditPaneStyle = (theme: Theme) => createStyles({
  chatBottomBar,
  chatInputBox,
  chatFiles,
  backdrop : {
    position:'fixed',
    top:0,
    left:0,
    width:'100vw',
    height:'100%',
    pointerEvents: 'none',
    backgroundColor: styleColors.blackAlpha23,
    zIndex: 1,
    transition: 'opacity 300ms',
  },
  editBox: {
    textAlign: 'center',
    position:'fixed',
    bottom:0,
    height: 260,
    minHeight:260, 
    maxHeight:260,
    width: '100%',
    zIndex: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  buttonOutlined,
  buttonContained,
  buttonContainedFAB : {
    borderRadius: '99px',
    // Brand purple in both themes, so Send matches light mode.
    backgroundColor: secondaryColor,
    color: '#FFFFFF',
    boxShadow: `${styleColors.blackAlpha63} 0px 0px 8px`,
  },
  button: {
    zIndex: 0,
    backgroundColor: styleColors.cornflowerBlue,
    position: 'absolute',
    padding: '0px 15px',
    minHeight: '46px',
    display: 'flex',
    alignItems: 'center',
    color: '#FFFFFF',
    borderRadius: '10px',
    left: '50%',
    transform: 'translate(-50%, 0%)',
    transition: 'all 0.3s',
    fontSize: '16px',
  },
  clearButton: {
    left: '50%',
    top: '50px',
    color: styleColors.greyDark3,
    padding: '10px 15px',
    zIndex: 0,
    position: 'absolute',
    transform: 'translate(-50%, 0%)',
    transition: 'all 0.5s',
  },
  buttonHighlight : {
    backgroundColor: styleColors.actionBlue,
    padding: '5px',
    marginLeft: '4px',
    borderRadius: '20px',
    minHeight: '16px',
    minWidth: '16px',
    textAlign: 'center',
  },
  editCountHighlight : {
    padding: '3px',
    minWidth: '16px',
    minHeight: '16px',
    textAlign: 'center',
    borderRadius: '20px',
    backgroundColor: styleColors.greyLight2,
    /* Badge bg is yellow when there are changes — same in both modes —
       so the number text must always be dark to remain readable. */
    color: '#000000',
    fontSize: '10px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  actionFooter : {
    gap:'10px',
    zIndex: 2,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    backgroundColor: styleColors.greyLight2,
    borderTop: `0.5px solid ${styleColors.greyMedium1}`,
    boxShadow: `0px 0px 10px ${styleColors.chromePurpleShadow}`,
    overflow: 'hidden',
    transition: 'all 0.5s',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px 12px 12px',
  },
  pane : {
    zIndex: 3,
    position: 'fixed',
    width: '100%',
    bottom: 0,
    height: '200px',
    backgroundColor: styleColors.white,
    border: `0.5px solid ${styleColors.greyMedium1}`,
    overflow: 'hidden',
    transition: 'all 0.5s',
    boxSizing: 'border-box',
    justifyContent: 'space-around',
    borderRadius: '12px 12px 0 0',
    display: 'flex',
    flexDirection: 'column',
  },
  paneDragger : {
    minHeight: '25px',
    width:'100%',
  },
  paneMarker : {
    width:'60px',
    height: '3px',
    backgroundColor: styleColors.greyLight3,
    position: 'absolute',
    top: '7px',
    borderRadius: '3px',
    left: 'calc(50% - 30px)',
  },
  paneOptions : {
    display:'flex',
    width: '100%',
    textAlign: 'center',
    placeContent: 'center',
    alignItems: 'center',
  },
  changeScheduleHeader : {
    display:'flex',
    width: '100%',
    textAlign: 'center',
    placeContent: 'center',
    alignItems: 'center', 
    fontWeight: 700,
    padding: '18px 0px 8px',
    flex:1,
  },
  changeInfoView : {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    padding: '24px',
  },
  changeInfoBox : {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: styleColors.greyLight1,
    padding: '24px',
    marginBottom: '40px',
    borderRadius: '8px',
    border: `1px solid ${styleColors.greyMedium1}`,
    boxShadow: `0px 2px 4px -1px ${styleColors.blackAlpha18},0px 4px 5px 0px ${styleColors.blackAlpha12},0px 1px 10px 0px ${styleColors.blackAlpha12}`
  },
  changeInfoHeader : {
    fontSize: '18px',
    marginBottom: '12px',
    fontWeight: 500,
    letterSpacing: '0.5px',
  },
  changeInfoCaption : {
    fontSize: '12px',
    marginBottom: '12px',
    fontWeight: 400,
  },
  changeInfoRow : {
    display: 'flex',
    flexDirection: 'row',
  },
  changeInfoColumn : {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  changeInfoLabel : {
    color:styleColors.greyMedium3,
    marginBottom: '10px',
    fontStyle: 'italic',
  },
  changeInfoValue : {
    fontWeight:600,
  },
  paneOption : {
    width: 'calc(100%/3)',
  },
  paneBackButton : {
    padding: '6px',
    marginLeft: '12px',
  },
  paneNextButton : {
    padding: '6px',
    marginRight: '12px',
  },
  backButton : {

  },
  paneReplacable : {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: styleColors.white,
    display: 'flex',
    flexDirection: 'column',
  },
  paneChange : {
    overflow:'auto',
    width: '100%',
    backgroundColor: styleColors.white,
    display: 'flex',
    flexDirection: 'column',
    flex:1,
  },
  paneActions : {
    display:'flex',
    width:'calc(100% - 24px)',
    flexDirection: 'column',
    backgroundColor: styleColors.greyLight2,
    margin: '0px 12px',
    boxSizing: 'border-box',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  paneAction : {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    borderBottom: `1px solid ${styleColors.greyMedium1}`,
    padding: '12px 0px',
    margin: '0px 12px',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 500,
  },
  showMoreOptions : {
    overflow: 'hidden',
    maxHeight: '500px',
    transition: 'max-height 0.3s',
  },
  paneActionIcon : {
    width: '24px',
    height: '24px',
    paddingRight: '12px',
  },
  paneActionTitle : {
    display: 'flex',
    gap: '3px',
    alignItems: 'center',
    flex: 1,
  },
  paneActionShowMore : {
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: 400,
    padding: '16px 8px',
    display: 'flex',
    gap: '3px',
    alignItems: 'center',
    flex: 1,
  },
  paneActionTitleSelectMin : {
    fontStyle: 'italic',
    fontWeight: 200,
  },
  paneChangeDaysStep : {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-around',
  },
  paneChangeArrowButton : {
    backgroundColor:`${styleColors.greyLight2} !important`
  },
  paneModifyDays : {
    fontSize: '11px',
    padding: '12px 0px',
    fontWeight: 600,
  },
  checkIcon : {
    height: '24px',
    margin: '-6px 0px',
    color: styleColors.successGreen,
  },
  kidsOption : {
    fontWeight: 200,
    fontStyle: 'italic',
    color: styleColors.greyMedium3,
  },
  messageText : {
    height: '100%',
    resize: 'none',
    boxSizing: 'border-box',
    padding: '5px',
    margin: '10px',
    border: `1px solid ${styleColors.greyMedium1}`,
    flex: 1,
  },
  dateRangeDaysAccordion : {
    overflow:'hidden',
    transition: 'all 0.5s',
  },
  headerTitle: {
    margin: '16px 0px 10px 14px',
    fontWeight: 600,
    fontSize: '15px',
  },
  actionFab : {
    backgroundColor: styleColors.white,
    boxShadow:`0px 0px 30px ${styleColors.greyShadow28}`,
  },
  actionFabHolder : {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    gap: '48px',
    display: 'flex',
    top: '24px',
    minWidth:'200px',
    justifyContent: 'center',
  },
  sendFabHolder : {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    // level with the wrench button, which is 62px high and 100px from the bottom
    bottom: '100px',
    height: '62px',
    display: 'flex',
    alignItems: 'center',
  },
  // same look as the help tips in the calendar header
  wrenchTip : {
    position: 'absolute',
    // just above the wrench button, which is 62px high, 100px from the bottom and 20px from the right
    right: '20px',
    bottom: '172px',
    maxWidth: '200px',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    padding: '6px 16px',
    fontSize: '0.875rem',
    lineHeight: '1.43',
    borderRadius: '4px',
    letterSpacing: '0.01071em',
    // Brand purple in both themes, so the text stays white in dark mode too.
    color: theme.palette.secondary.contrastText,
    fontWeight: 500,
    backgroundColor: secondaryColor,
    boxShadow: `0px 3px 5px -1px ${styleColors.blackAlpha18}, 0px 6px 10px 0px ${styleColors.blackAlpha12}, 0px 1px 18px 0px ${styleColors.blackAlpha12}`,
    cursor: 'pointer',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
  wrenchTipArrow : {
    position: 'absolute',
    bottom: '-16px',
    // centered over the 62px wide wrench button
    right: '23px',
    width: 0,
    height: 0,
    border: `8px solid ${styleColors.transparent}`,
    borderTop: '8px solid '+secondaryColor,
  },
  wrenchTipClose : {
    display: 'flex',
    opacity: 0.9,
    padding: '7px 0',
    fontSize: '22px',
    marginLeft: '12px',
  },
  helpText : {
    color: styleColors.blackAlpha23,
    display: 'flex',
    fontFamily: 'Metropolis, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    fontStretch: '100%',
    fontStyle: 'normal',
    fontWeight: 500,
    letterSpacing: '1.5px',
    pointerEvents: 'none',
    textIndent: '0px',
    textTransform: 'uppercase',
    userSelect: 'none',
    wordSpacing: '0px',
    textWrap: 'balance',
  }
});



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/EditPane.style.ts